import {
  Button,
  Header,
  Tabs,
} from '@cloudscape-design/components';
import { PartsTabs } from '@parallel-fluidics/shared/constants';
import { ReactFlowProvider } from '@xyflow/react';
import React, {
  useState,
} from 'react';
import { useSearchParams } from 'react-router-dom';

import PartsTable from './partsTable';
import PPartProvider, { usePPartData } from './pPartProvider';
import ProjectPartsFlow from './projectPartsFlow';

function TabsLayout() {
  const { setOpenAddModal, project } = usePPartData();
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTabId, setActiveTabId] = useState(searchParams.get('partDisplay') || PartsTabs.LIST);

  const handleTabChange = (tabId) => {
    setActiveTabId(tabId);

    const newParams = new URLSearchParams(searchParams.toString());
    newParams.set('partDisplay', tabId);
    setSearchParams(newParams);
  };

  return (
    <>
      <Header
        variant="awsui-h1-sticky"
      >
        {`Parts ${project?.name ? `for ${project.name}` : ''}`}
      </Header>
      <Tabs
        activeTabId={activeTabId}
        onChange={({ detail }) => handleTabChange(detail.activeTabId)}
        fitHeight
        tabs={[
          {
            label: 'Parts List',
            id: PartsTabs.LIST,
            content: <PartsTable />,
          },
          {
            label: 'Product Flow',
            id: PartsTabs.FLOW,
            content: (
              <ReactFlowProvider>
                <ProjectPartsFlow />
              </ReactFlowProvider>
            ),
          },
        ]}
        actions={(
          <Button
            variant="normal"
            onClick={() => {
              setOpenAddModal(true);
            }}
          >
            Add Part
          </Button>
        )}
      />
    </>
  );
}

export default function ProjectPartsPage() {
  return (
    <PPartProvider>
      <TabsLayout />
    </PPartProvider>
  );
}
